import React from "react";
import { Form, Input, InputNumber, Select, Button, Space } from "antd";
import { CreatePatientRequest } from "../../types/Billing";

const { Option } = Select;
const { TextArea } = Input;

interface PatientFormProps {
  onSubmit: (patientData: CreatePatientRequest) => void;
  onCancel: () => void;
  initialValues?: Partial<CreatePatientRequest>;
  loading?: boolean;
}

const PatientForm: React.FC<PatientFormProps> = ({
  onSubmit,
  onCancel,
  initialValues,
  loading = false,
}) => {
  const [form] = Form.useForm();

  const handleSubmit = (values: CreatePatientRequest) => {
    onSubmit(values);
    form.resetFields();
  };

  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={initialValues}
      onFinish={handleSubmit}
    >
      <Form.Item
        label="Patient Name"
        name="name"
        rules={[
          { required: true, message: "Please enter patient name" },
          { min: 2, message: "Name must be at least 2 characters" },
        ]}
      >
        <Input placeholder="Enter patient name" />
      </Form.Item>

      <Form.Item
        label="Age"
        name="age"
        rules={[
          { required: true, message: "Please enter age" },
          {
            type: "number",
            min: 1,
            max: 150,
            message: "Please enter valid age",
          },
        ]}
      >
        <InputNumber
          min={1}
          max={150}
          style={{ width: "100%" }}
          placeholder="Enter age"
        />
      </Form.Item>

      <Form.Item
        label="Gender"
        name="gender"
        rules={[{ required: true, message: "Please select gender" }]}
      >
        <Select placeholder="Select gender">
          <Option value="male">Male</Option>
          <Option value="female">Female</Option>
          <Option value="other">Other</Option>
        </Select>
      </Form.Item>

      <Form.Item
        label="Phone Number"
        name="phone"
        rules={[
          { required: true, message: "Please enter phone number" },
          {
            pattern: /^\d{10}$/,
            message: "Please enter valid 10-digit phone number",
          },
        ]}
      >
        <Input placeholder="Enter 10-digit phone number" />
      </Form.Item>

      <Form.Item
        label="Address"
        name="address"
        rules={[{ required: true, message: "Please enter address" }]}
      >
        <TextArea rows={3} placeholder="Enter complete address" />
      </Form.Item>

      <div className="text-right">
        <Space>
          <Button type="default" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" loading={loading}>
            {initialValues ? "Update Patient" : "Add Patient"}
          </Button>
        </Space>
      </div>
    </Form>
  );
};

export default PatientForm;
